// extracted by mini-css-extract-plugin
module.exports = {"customModal":"styles_customModal__2wE0D","closeButton":"styles_closeButton__1YQzY","container":"styles_container__aarLQ"};